import React, { createContext, useState } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [ userData, setUserData ] = useState(null);
  const [ authStatusMsg, setAuthStatusMsg ] = useState('');
  const [ alertMsg, setAlertMsg ] = useState('');

  return (
    <UserContext.Provider
      value={{
        userData,
        setUserData,
        authStatusMsg,
        setAuthStatusMsg,
        alertMsg,
        setAlertMsg
        }}
      >
      { children }
    </UserContext.Provider>
  )
}

export default UserContext;